'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSignals$0024 from "./presto.-Signals$.js";
var $p;
/** @constructor */
function $c_Lpresto_Mediator$$anon$18(request$2, bus$2, results$2, busy$4, tmp$2, outer) {
  this.b8y = null;
  this.b8x = null;
  this.a8X = null;
  this.a8W = null;
  this.b8z = null;
  this.b8y = request$2;
  this.b8x = bus$2;
  this.a8X = results$2;
  this.a8W = busy$4;
  this.b8z = tmp$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_Mediator$$anon$18 as $c_Lpresto_Mediator$$anon$18 };
$p = $c_Lpresto_Mediator$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Mediator$$anon$18;
/** @constructor */
function $h_Lpresto_Mediator$$anon$18() {
}
export { $h_Lpresto_Mediator$$anon$18 as $h_Lpresto_Mediator$$anon$18 };
$h_Lpresto_Mediator$$anon$18.prototype = $p;
$p.agm = (function() {
  return this.b8x.bp;
});
$p.a47 = (function() {
  return this.a8X.bs;
});
$p.agt = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_Implicits$RichSource$().bb(this.b8z, this.a8X);
});
$p.acY = (function() {
  return $j_presto$002e$002dSignals$0024.$m_Lpresto_Signals$().p2(this.a8W, this.b8y, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction2(((_$11, _$12) => ((!(!_$11)) || _$12.mq()))));
});
$p.An = (function() {
  return this.a8W.R();
});
$p.cQW = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a47(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$13) => _$13.dc())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cNy = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cQW(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (!_$14.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => _$15.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cFa = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a47(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$16) => _$16.cx7().cR0().dc())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.afa = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cFa(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$17) => (!_$17.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$18) => _$18.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_Mediator$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Mediator$$anon$18, "presto.Mediator$$anon$18", ({
  Mz: 1,
  MA: 1
}));
export { $d_Lpresto_Mediator$$anon$18 as $d_Lpresto_Mediator$$anon$18 };
//# sourceMappingURL=presto.-Mediator$$anon$18.js.map
